'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    min-height: 1px;\n    padding: 0px 8px;\n    background: #fff;\n    margin-top: 10px;\n    margin-bottom: 5px;\n    box-shadow: 0 -3px 5px 0 rgb(0 0 0 / 6%);\n\n    img {\n        max-width: 100%;\n        margin-bottom: 15px;\n    }\n\n    h1 {\n        display: inline-block;\n        font-size: 20px;\n        font-weight: 500;\n        line-height: 1;\n        padding: 0px 6px;\n        margin-top: 10px;\n        margin-bottom: 5px;\n    }\n'], ['\n    min-height: 1px;\n    padding: 0px 8px;\n    background: #fff;\n    margin-top: 10px;\n    margin-bottom: 5px;\n    box-shadow: 0 -3px 5px 0 rgb(0 0 0 / 6%);\n\n    img {\n        max-width: 100%;\n        margin-bottom: 15px;\n    }\n\n    h1 {\n        display: inline-block;\n        font-size: 20px;\n        font-weight: 500;\n        line-height: 1;\n        padding: 0px 6px;\n        margin-top: 10px;\n        margin-bottom: 5px;\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactScroll = require('react-scroll');

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Header = _styledComponents2.default.div(_templateObject);

var Tag = function Tag(_ref) {
    var tag = _ref.tag,
        page = _ref.page,
        text = _ref.text,
        item = _ref.item,
        name = _ref.name;
    return _react2.default.createElement(
        _reactScroll.Element,
        { name: name },
        _react2.default.createElement(
            Header,
            null,
            _react2.default.createElement(_Text2.default, { text: '<' + tag + ' ' + (item.css || '') + '>' + (page + 1 ? page + 1 + '. ' : '') + (text || '') + '</' + tag + '>' })
        )
    );
};

Tag.propTypes = {
    name: _propTypes2.default.string.isRequired,
    page: _propTypes2.default.number.isRequired,
    tag: _propTypes2.default.string.isRequired,
    text: _propTypes2.default.string.isRequired,
    item: _propTypes2.default.object.isRequired
};

exports.default = Tag;